import { defineStore } from "pinia";
import { api } from "@/services/api";

export const DadosStore = defineStore('Dados', {
  state() {
    return {
      // Vue Data()
      CursoAberto:'',
      AulaAberta:'',
      ProvaAberta:'',
    }
  },
  actions: {
    // Vue methods:{}
    setCursoAberto(curso){
      this.CursoAberto = curso
    },
    setAulaAberta(aula){
      this.AulaAberta = aula
    },
  },
  getters: {
    // Vue Computed:{}
    
  },
})